export enum ORGANIZATION_UNIT_CLASSIFY {
  TTCSKH = 6,
  DONVIXULY = 7,
  BANCHUCNANG = 8,
  DONVIPHUTRO = 9,
  PHONGDOI = 10
}
